/** One word per document state - **G-Wauditor-13**.
 *
 * The same state had three names on three screens: a document a person had accepted was *Accepted* in
 * Documents, *Ready* in Dashboards and `verified` in the evidence list an auditor files as a
 * workpaper; one a person had put aside was *Set aside* and `rejected`. Seven tables carried the words
 * (the library's filter, the upload card, the batch table, the funnel, the state pill, the stage chip,
 * the server's stage names), each typed once.
 *
 * **This is the table.** A document's state (`evidence/states.py`) has one word here, and the server's
 * stage (`evidence/stages.py`, one stage per state) takes its word from the state it stands for, so the
 * two cannot be given different words. The server prints the same words in the evidence list and its
 * export (`stages.STATE_WORDS`); `test_document_state_words.py` compares that table to this one.
 *
 * *Needs review* is the state; the Processing tab that lists those documents is called *To review*,
 * because a tab names the work and a state names the document. The upload chip's *Read* and *Matched*
 * are finer readings of the one state `awaiting_review` and are the stage chip's own.
 */

/** A document's lifecycle state, in a person's word. */
export const DOCUMENT_STATE_WORDS: Readonly<Record<string, string>> = {
  received: "Received",
  validated: "Checked",
  extracting: "Reading",
  awaiting_review: "Needs review",
  verified: "Accepted",
  quarantined: "Refused",
  rejected: "Set aside",
  superseded: "Replaced",
};

/** The state each server stage stands for (`evidence/stages.py` `STAGE_OF`, one stage per state). */
export const STATE_OF_STAGE: Readonly<Record<string, string>> = {
  received: "received",
  checked: "validated",
  being_read: "extracting",
  awaiting_review: "awaiting_review",
  ready: "verified",
  could_not_be_read: "quarantined",
  set_aside: "rejected",
  replaced: "superseded",
};

export function stateWord(state: string): string {
  return DOCUMENT_STATE_WORDS[state] ?? state.replace(/_/g, " ");
}

/** The server's stage words: the word of the state the stage stands for. */
export const STAGE_WORDS: Readonly<Record<string, string>> = Object.fromEntries(
  Object.entries(STATE_OF_STAGE).map(([stage, state]) => [stage, DOCUMENT_STATE_WORDS[state] as string]),
);

export function stageWord(stage: string): string {
  return STAGE_WORDS[stage] ?? stage.replace(/_/g, " ");
}
